import util from './shared/util.js';
import config from '../config.js';

export const createCatalogClient = path => {
  const url = `${config.server.url}:${config.server.webServicesPort}/${path}/`;
  return {
    selectAll: callback => util.getJSON(`${url}select-all`, callback),
    filter: (data, callback) => util.putJSON(`${url}select-all`, data, callback),
    select: (data, callback) => util.putJSON(`${url}select`, data, callback),
    create: (data, callback) => util.putJSON(`${url}create`, data, callback),
    update: (data, callback) => util.putJSON(`${url}update`, data, callback),
    delete: (data, callback) => util.putJSON(`${url}delete`, data, callback),
  };
};
export const cdoBeingTemplate = createCatalogClient('being-template');
export const cdoAbilityList = createCatalogClient('ability-list');
export const cdoBiome = createCatalogClient('biome');

export const cdoProvisionTemplate = createCatalogClient('provision-template');
